import { useState } from 'react'
import { orange } from '@material-ui/core/colors'
import { Tooltip } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import { Alert, Skeleton } from '@material-ui/lab'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerMovimientoCuentaCliente } from '../../../ducks/clientesDuck'
import { formatDinero } from "./../../../utils/formatDinero"
import { FormatoFechaIso } from '../../../utils/FormatFecha'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import { catRoles } from '../../../constant/catRoles'
const columns = [
  { id: "calveRastreo", minWidth: 150, align: "center", label: "Clave de rastreo" },
  { id: "monto", minWidth: 150, align: "center", label: "Monto" },
  { id: "tipoCambio", minWidth: 50, align: "center", label: "T. C." },
  { id: "conversion", minWidth: 50, align: "center", label: "Conversion" },
  { id: "fecha", minWidth: 150, align: "center", label: "Fecha" },
  { id: "tipoPago", minWidth: 50, align: "center", label: "Tipo pago" },
  { id: "corteCaja", minWidth: 50, align: "center", label: "Corte de caja" },
]

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '0'
  },
  container: {
    maxHeight: 440,
  },
})

export default function TPagos() {
  const { referencia } = useSelector(store => store.cliente)
  const { profile } = useSelector(store => store.logeo)
  const rows = useSelector(store => store.cliente.movimientos)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(obtenerMovimientoCuentaCliente({ referencia }))
  }, [dispatch, referencia])

  const classes = useStyles()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  if (referencia === "")
    return (
      <div className="TarjetaClienta-root">
        <div className="contenido">
          <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
          <Skeleton variant="rect" height={250} />
        </div>
      </div>
    )
  if (rows.length === 0)
    return (
      <div className="TarjetaClienta-root">
        <div className="contenido">
          <Alert className="alerta" severity="info">No hay moviminetos para mostrar</Alert>
        </div>
      </div>
    )
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id_movCuenta}>
                  <TableCell align='center'>
                    {`${row.Referencia}`}
                    <br />
                    {`${row.ClaveRastreo}`}
                  </TableCell>
                  <TableCell align="center">
                    {`${formatDinero(row.monto)}`}
                  </TableCell>
                  <TableCell align="center">
                    {`${formatDinero(row.tipoCambio)}`}
                  </TableCell>
                  <TableCell align="center">
                    {`${formatDinero(row.monto / row.tipoCambio)}`}
                  </TableCell>
                  <TableCell align="center">
                    {`${FormatoFechaIso({ date: row.Fecha, formato: "dd MMMM yyyy" }).toUpperCase()}`}
                  </TableCell>
                  <TableCell align="center">
                    {`${row.TipoPago}`}
                  </TableCell>
                  <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexFlow: "column" }}>
                      {
                        (row?.CorteCaja?.TipoCambio > 0 && row?.EsCorteCaja) &&
                        <Tooltip title="Aplicado">
                          <CheckCircleIcon color='secondary' />
                        </Tooltip>

                      }
                      {
                        (row?.CorteCaja?.TipoCambio <= 0 && row?.EsCorteCaja) &&
                        <Tooltip title="No Aplicado">
                          <ErrorIcon style={{color: orange[400] }} />
                        </Tooltip>
                      }
                      {
                        (row?.CorteCaja?.TipoCambio > 0 && row?.EsCorteCaja && profile.Rol?.Id === catRoles.ADMINISTRADOR) &&
                        `${formatDinero(row.CorteCaja?.TipoCambio)}`
                      }
                      {
                        (!row?.EsCorteCaja) &&
                        `No Aplica`
                      }
                    </div>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  )
}